// src/components/ui/RadarLoader.js
import React from 'react';
import radarImg from './../../assets/images/image010.png';
import './../../styles/MirrorLoader.css';

export default function MirrorLoader({ width = '4rem', height = '1.5rem' }) {
  return (
    <div
      className="mirror-loader"
      style={{ width, height }}
    />
  );
}
